/**
 * One in-page "leave?" check (QA P2-6). A view with unsaved edits (the
 * dealership settings form) registers a guard that asks the user in the page
 * and resolves true (leave) or false (stay); in-app navigation that would
 * drop those edits (admin section nav, leaving the console) awaits
 * `confirmLeave()` first. With no guard registered it resolves true at once.
 */
let current = null;

/** Register `ask` (() => Promise<boolean>); returns the unregister function. */
export const setLeaveGuard = (ask) => {
    current = ask;
    return () => { if (current === ask) current = null; };
};

/** True when the user may leave (no guard, or they chose to discard). */
export const confirmLeave = async () => (current ? Boolean(await current()) : true);

/** Whether a view currently holds unsaved edits (callers can stay synchronous otherwise). */
export const hasLeaveGuard = () => current !== null;
